import Validator from './validator.js';

export default class DealerServiceValidator extends Validator {

    constructor(input){
        super(input);
        this.previous = {};
        this.url = input.el.dataset.dealerServiceApi;
        this.location = input.el.dataset.dealerLocation;
        this.param = input.el.dataset.dealerParam;
        this.error = input.parent.el.querySelector('.form_field_error_message');
        this.defaultMessage = this.error.innerHTML;
    }        

    dealer(){
        const params = this.location === 'hash' ? new URLSearchParams(window.location.hash.split("?")[1] || "") : new URLSearchParams(location.search || "");
        return params.get(this.param);    
    }

    valid() {
        const service = this.input.el.value;
        const dealer = this.dealer();
        if (!service || !dealer) { return Promise.resolve(false); }
        if (service === this.previous.service && dealer === this.previous.dealer){ return Promise.resolve(this.previous.success) }

        return new Promise((resolve) => {
            fetch(this.url + `?dealer=${dealer}&service=${service}`)
                .then((response) => response.json())
                .then((result) => this.previous = { service: service, dealer: dealer, success: result.success, message: result.message })
                .then((previous) => this.message(previous))
                .then((previous) => resolve(previous.success))
                .catch((error) => resolve(true));
        });
    }

    message(previous){
        if(!previous.success){ this.error.innerHTML = previous.message; }
        return previous;
    }

    static applies(input) {
        return input.el.dataset.dealerServiceApi !== undefined;
    }
}
